const delimeter = ',';

type ConverterFunction = (paramName: string) => string | undefined;
type Callback = (result: string) => void;
type GetCurrentUrl = () => string;

export const registerKeepQueryParams = (callback?: Callback, getCurrentUrl?: GetCurrentUrl) => {
  if (!callback) {
    callback = (result) => {
      window.location.href = result;
    };
  }

  if (!getCurrentUrl) {
    getCurrentUrl = () => {
      return window.location.search;
    };
  }

  const elements = Array.from(document.querySelectorAll('[data-keep-params]'));

  for (const element of elements) {
    if (!(element instanceof HTMLElement)) {
      continue;
    }

    element.addEventListener('click', handleClick(element, callback, getCurrentUrl));
  }
};

const handleClick = (element: HTMLElement, callback: Callback, getCurrentUrl: GetCurrentUrl) => (event: MouseEvent) => {
  if (!element.dataset.keepParams) {
    return;
  }

  const paramNames = element.dataset.keepParams.split(delimeter);
  let href = element.getAttribute('href');

  if (!href) {
    return;
  }

  event.preventDefault();

  let separator = href.includes('?') ? '&' : '?';

  for (const paramName of paramNames) {
    const keyValuePair = toKeyValuePair(paramName, getCurrentUrl);

    if (keyValuePair) {
      href += separator + keyValuePair;
      separator = '&';
    }
  }

  callback(href);
};

const toKeyValuePair = (paramName: string, getCurrentUrl: GetCurrentUrl): string | undefined => {
  const converters: ConverterFunction[] = [inputValueToKeyValuePair, queryParamToKeyValuePair(getCurrentUrl)];

  for (const converter of converters) {
    const keyValuePair = converter(paramName);

    if (keyValuePair) {
      return keyValuePair;
    }
  }

  return undefined;
};

const inputValueToKeyValuePair = (paramName: string): string | undefined => {
  const element = document.querySelector(`[name="${paramName}"]`);

  if (!(element instanceof HTMLInputElement) || !element.value) {
    return undefined;
  }

  element.blur();
  element.focus();
  const paramValue = element.value;
  return `${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`;
};

const queryParamToKeyValuePair =
  (getCurrentUrl: GetCurrentUrl) =>
  (paramName: string): string | undefined => {
    const urlParams = new URLSearchParams(getCurrentUrl());
    const paramValue = urlParams.get(paramName);

    if (!paramValue) {
      return undefined;
    }

    return `${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`;
  };
